import { render, staticRenderFns } from "./CarouselBlock.vue?vue&type=template&id=7adb3f04&scoped=true&"
import script from "./CarouselBlock.vue?vue&type=script&lang=js&"
export * from "./CarouselBlock.vue?vue&type=script&lang=js&"
import style0 from "./styles/CarouselBlock.scss?vue&type=style&index=0&id=7adb3f04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adb3f04",
  null
  
)

export default component.exports